export enum ListType {
  Dotted = 'dotted',
  Numbered = 'numbered',
}
